import { CSSProperties } from "react";
import { usePlayerColor } from "~/jsx/hook/usePlayerColor";
import { Colors } from "~/jsx/theme";
import { XFlagSvg } from "./svg";

export const XPlayerIcon = ({
  playerId,
  width,
  color,
  style,
}: {
  playerId?: string;
  width: number;
  color?: string;
  style?: CSSProperties;
}) => {
  const gameColor = usePlayerColor(playerId) ?? Colors.common.black;
  return (
    <XFlagSvg
      color={color ?? gameColor}
      width={width}
      style={{ verticalAlign: "middle", ...style }}
    />
  );
};
